module.exports = __webpack_public_path__ + "static/media/logo.9b21ca64.svg";